import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { I18nService } from '../../../core/services/i18n.service';
import {
  STORE_HOTLINE_DISPLAY,
  STORE_HOTLINE_TEL_HREF,
  STORE_MOBILE_DISPLAY,
  STORE_MOBILE_TEL_HREF,
  STORE_WHATSAPP_HREF,
} from '../../../core/constants/store-contact';

@Component({
  selector: 'app-site-footer',
  templateUrl: './site-footer.component.html',
  styleUrls: ['./site-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SiteFooterComponent {
  readonly language$ = this.i18n.language$;
  callChooserOpen = false;

  readonly mobileTelHref = STORE_MOBILE_TEL_HREF;
  readonly hotlineTelHref = STORE_HOTLINE_TEL_HREF;
  readonly mobileDisplay = STORE_MOBILE_DISPLAY;
  readonly hotlineDisplay = STORE_HOTLINE_DISPLAY;

  readonly socialLinks = [
    {
      key: 'whatsapp',
      labelKey: 'footer.whatsapp',
      href: STORE_WHATSAPP_HREF,
      iconUrl: '/assets/icons/figma/social-rail-1.svg',
      isCallChooser: false,
    },
    {
      key: 'phone',
      labelKey: 'footer.phone',
      href: STORE_MOBILE_TEL_HREF,
      iconUrl: '/assets/icons/figma/social-rail-2.svg',
      isCallChooser: true,
    },
    {
      key: 'facebook',
      labelKey: 'footer.facebook',
      href: 'https://www.facebook.com/people/Zerotech-Stores/61572042029705/',
      iconUrl: '/assets/icons/figma/social-rail-3.svg',
      isCallChooser: false,
    },
  ] as const;

  constructor(
    private readonly i18n: I18nService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  setLanguage(lang: 'ar' | 'en'): void {
    this.i18n.setLanguage(lang);
  }

  onSocialClick(event: Event, social: { isCallChooser: boolean }): void {
    if (!social.isCallChooser) return;
    event.preventDefault();
    this.callChooserOpen = true;
    this.cdr.markForCheck();
  }

  closeCallChooser(): void {
    this.callChooserOpen = false;
    this.cdr.markForCheck();
  }
}
